// Domain configuration for Scubamail
export const DOMAIN_CONFIG = {
  production: {
    /** Public marketing / landing site only — not the app. */
    landingDomain: 'scubamail.io',
    /** @deprecated Use appDomain for app URLs; kept for DNS / legacy references. */
    mainDomain: 'scubamail.io',
    sendingDomain: 'send.scubamail.in',
    /** App-hosted API routes (Firebase hosting rewrites on app.scubamail.io). */
    apiDomain: 'app.scubamail.io',
    appDomain: 'app.scubamail.io',
  },

  FUTURE: {
    landingDomain: 'scubamail.io',
    mainDomain: 'scubamail.io',
    sendingDomain: 'send.scubamail.in',
    apiDomain: 'app.scubamail.io',
    appDomain: 'app.scubamail.io',
  },
};

/** Canonical HTTPS origin for the product app (links in emails, unsubscribe, OAuth). */
export const APP_WEB_ORIGIN = `https://${DOMAIN_CONFIG.FUTURE.appDomain}`;

/** Public marketing site — use for "Powered by Scubamail" branding links in footers. */
export const LANDING_WEB_ORIGIN = `https://${DOMAIN_CONFIG.FUTURE.landingDomain}`;

// Current active configuration
export const ACTIVE_DOMAIN = DOMAIN_CONFIG.FUTURE;

// DNS record types
export interface DNSRecord {
  type: 'TXT' | 'CNAME' | 'MX';
  name: string;
  value: string;
  priority?: number;
}

// DNS records for scaledots.com
export const DNS_RECORDS: Record<string, DNSRecord> = {
  // SPF Record
  SPF: {
    type: 'TXT' as const,
    name: 'scubamail.io',
    value: 'v=spf1 include:amazonses.com include:send.scubamail.in ~all'
  },

  // DKIM Record
  DKIM: {
    type: 'CNAME' as const,
    name: 'scubamail._domainkey.scubamail.io',
    value: 'scubamail._domainkey.send.scubamail.in'
  },

  // DMARC Record
  DMARC: {
    type: 'TXT' as const,
    name: '_dmarc.scubamail.io',
    value: 'v=DMARC1; p=quarantine; rua=mailto:dmarc@scubamail.io; ruf=mailto:dmarc@scubamail.io; fo=1'
  },

  // Sending Domain SPF
  SENDING_SPF: {
    type: 'TXT' as const,
    name: 'send.scubamail.in',
    value: 'v=spf1 include:amazonses.com ~all'
  },

  // Sending Domain DKIM
  SENDING_DKIM: {
    type: 'CNAME' as const,
    name: 'scubamail._domainkey.send.scubamail.in',
    value: 'scubamail._domainkey.scubamail.io'
  },

  // Sending Domain DMARC
  SENDING_DMARC: {
    type: 'TXT' as const,
    name: '_dmarc.send.scubamail.in',
    value: 'v=DMARC1; p=quarantine; rua=mailto:dmarc@scubamail.io; ruf=mailto:dmarc@scubamail.io; fo=1'
  },

  // MX Record for replies
  MX: {
    type: 'MX' as const,
    name: 'send.scubamail.in',
    value: '10 mail.scubamail.io',
    priority: 10
  }
};

// Email templates with domain branding
export const EMAIL_TEMPLATES = {
  verification: {
    fromName: 'Scubamail',
    fromEmail: 'noreply@scubamail.io',
    replyTo: 'support@scubamail.io'
  },
  marketing: {
    fromName: 'Scubamail Team',
    fromEmail: 'hello@scubamail.io',
    replyTo: 'hello@scubamail.io'
  },
  support: {
    fromName: 'Scubamail Support',
    fromEmail: 'support@scubamail.io',
    replyTo: 'support@scubamail.io'
  }
};

// AWS SES Configuration for scaledots.com
export const SES_CONFIG = {
  region: 'us-east-1', // or your preferred region
  verifiedEmails: [
    'noreply@scubamail.io',
    'hello@scubamail.io',
    'support@scubamail.io',
    'admin@scubamail.io'
  ],
  verifiedDomains: [
    'scubamail.io',
    'send.scubamail.in'
  ]
};

const domainConfig = {
  DOMAIN_CONFIG,
  ACTIVE_DOMAIN,
  DNS_RECORDS,
  EMAIL_TEMPLATES,
  SES_CONFIG
};

export default domainConfig;
